import { starterPlugin } from './plugin.ts';

export { starterPlugin, StarterService } from './plugin.ts';
export default starterPlugin;
